// Hershey Sans 1-stroke font - ALL 62 characters (0-9, a-z, A-Z)
// Public domain, originally created by Dr. Allen Vincent Hershey (1967)
// SVG font prepared by Windell H. Oskay, www.evilmadscientist.com
// https://github.com/techninja/hersheytextjs

export const strokePaths = {
  '0': [
    [
      { x: 67.8, y: 25 },
      { x: 46.5, y: 32.3 },
      { x: 32, y: 53.5 },
      { x: 25, y: 89.4 },
      { x: 25, y: 110.6 },
      { x: 32, y: 146.5 },
      { x: 46.5, y: 167.9 },
      { x: 67.8, y: 175 },
      { x: 82.1, y: 175 },
      { x: 103.6, y: 167.9 },
      { x: 117.7, y: 146.5 },
      { x: 124.9, y: 110.6 },
      { x: 124.9, y: 89.4 },
      { x: 117.7, y: 53.5 },
      { x: 103.6, y: 32.3 },
      { x: 82.1, y: 25 },
      { x: 67.8, y: 25 },
    ]
  ],
  '1': [
    [
      { x: 25, y: 53.5 },
      { x: 39, y: 46.5 },
      { x: 60.6, y: 25 },
      { x: 60.6, y: 175 },
    ]
  ],
  '2': [
    [
      { x: 32, y: 60.8 },
      { x: 32, y: 53.5 },
      { x: 39.3, y: 39.5 },
      { x: 46.5, y: 32.3 },
      { x: 60.6, y: 25 },
      { x: 89.1, y: 25 },
      { x: 103.6, y: 32.3 },
      { x: 110.6, y: 39.5 },
      { x: 117.7, y: 53.5 },
      { x: 117.7, y: 68.1 },
      { x: 110.6, y: 82.1 },
      { x: 96.4, y: 103.6 },
      { x: 25, y: 175 },
      { x: 124.9, y: 175 },
    ]
  ],
  '3': [
    [
      { x: 39.3, y: 25 },
      { x: 117.7, y: 25 },
      { x: 75.1, y: 82.1 },
      { x: 96.4, y: 82.1 },
      { x: 110.6, y: 89.4 },
      { x: 117.7, y: 96.6 },
      { x: 124.9, y: 117.9 },
      { x: 124.9, y: 132.2 },
      { x: 117.7, y: 153.6 },
      { x: 103.6, y: 167.9 },
      { x: 82.1, y: 175 },
      { x: 60.6, y: 175 },
      { x: 39.3, y: 167.9 },
      { x: 32, y: 160.7 },
      { x: 25, y: 146.5 },
    ]
  ],
  '4': [
    [
      { x: 96.4, y: 25 },
      { x: 25, y: 125.2 },
      { x: 132.2, y: 125.2 },
    ],
    [
      { x: 96.4, y: 25 },
      { x: 96.4, y: 175 },
    ]
  ],
  '5': [
    // Stroke 1: vertical bar going down from top-left + the curve
    [
      { x: 39.3, y: 25 },
      { x: 32, y: 89.4 },
      { x: 39.3, y: 82.1 },
      { x: 60.6, y: 75.1 },
      { x: 82.1, y: 75.1 },
      { x: 103.6, y: 82.1 },
      { x: 117.7, y: 96.6 },
      { x: 124.9, y: 117.9 },
      { x: 124.9, y: 132.2 },
      { x: 117.7, y: 153.6 },
      { x: 103.6, y: 167.9 },
      { x: 82.1, y: 175 },
      { x: 60.6, y: 175 },
      { x: 39.3, y: 167.9 },
      { x: 32, y: 160.7 },
      { x: 25, y: 146.5 },
    ],
    // Stroke 2: horizontal bar at top
    [
      { x: 39.3, y: 25 },
      { x: 110.6, y: 25 },
    ]
  ],
  '6': [
    [
      { x: 110.6, y: 46.5 },
      { x: 103.6, y: 32.3 },
      { x: 82.1, y: 25 },
      { x: 68.1, y: 25 },
      { x: 46.5, y: 32.3 },
      { x: 32.3, y: 53.5 },
      { x: 25, y: 89.4 },
      { x: 25, y: 125.2 },
      { x: 32.3, y: 153.6 },
      { x: 46.5, y: 167.9 },
      { x: 68.1, y: 175 },
      { x: 75.1, y: 175 },
      { x: 96.6, y: 167.9 },
      { x: 110.6, y: 153.6 },
      { x: 117.9, y: 132.2 },
      { x: 117.9, y: 125.2 },
      { x: 110.6, y: 103.6 },
      { x: 96.6, y: 89.4 },
      { x: 75.1, y: 82.1 },
      { x: 68.1, y: 82.1 },
      { x: 46.5, y: 89.4 },
      { x: 32.3, y: 103.6 },
      { x: 25, y: 125.2 },
    ]
  ],
  '7': [
    [
      { x: 25, y: 25 },
      { x: 124.9, y: 25 },
      { x: 53.5, y: 175 },
    ]
  ],
  '8': [
    [
      { x: 60.6, y: 25 },
      { x: 39.3, y: 32.3 },
      { x: 32, y: 46.5 },
      { x: 32, y: 60.8 },
      { x: 39.3, y: 75.1 },
      { x: 53.5, y: 82.1 },
      { x: 82.1, y: 89.4 },
      { x: 103.6, y: 96.6 },
      { x: 117.7, y: 110.6 },
      { x: 124.9, y: 125.2 },
      { x: 124.9, y: 146.5 },
      { x: 117.7, y: 160.7 },
      { x: 110.6, y: 167.9 },
      { x: 89.1, y: 175 },
      { x: 60.6, y: 175 },
      { x: 39.3, y: 167.9 },
      { x: 32, y: 160.7 },
      { x: 25, y: 146.5 },
      { x: 25, y: 125.2 },
      { x: 32, y: 110.6 },
      { x: 46.5, y: 96.6 },
      { x: 67.8, y: 89.4 },
      { x: 96.4, y: 82.1 },
      { x: 110.6, y: 75.1 },
      { x: 117.7, y: 60.8 },
      { x: 117.7, y: 46.5 },
      { x: 110.6, y: 32.3 },
      { x: 89.1, y: 25 },
      { x: 60.6, y: 25 },
    ]
  ],
  '9': [
    [
      { x: 117.7, y: 75.1 },
      { x: 110.6, y: 46.5 },
      { x: 96.4, y: 32.3 },
      { x: 75.1, y: 25 },
      { x: 67.8, y: 25 },
      { x: 46.5, y: 32.3 },
      { x: 32, y: 46.5 },
      { x: 25, y: 68.1 },
      { x: 25, y: 75.1 },
      { x: 32, y: 96.6 },
      { x: 46.5, y: 110.6 },
      { x: 67.8, y: 117.9 },
      { x: 75.1, y: 117.9 },
      { x: 96.4, y: 110.6 },
      { x: 110.6, y: 96.6 },
      { x: 117.7, y: 75.1 },
      { x: 117.7, y: 110.6 },
      { x: 110.6, y: 146.5 },
      { x: 96.4, y: 167.9 },
      { x: 75.1, y: 175 },
      { x: 60.6, y: 175 },
      { x: 39.3, y: 167.9 },
      { x: 32, y: 153.6 },
    ]
  ],
  'A': [
    [
      { x: 82.1, y: 25 },
      { x: 25, y: 175 },
    ],
    [
      { x: 82.1, y: 25 },
      { x: 139.2, y: 175 },
    ],
    [
      { x: 46.3, y: 125.2 },
      { x: 117.9, y: 125.2 },
    ]
  ],
  'B': [
    // Stroke 1: vertical bar
    [
      { x: 25, y: 25 },
      { x: 25, y: 175 },
    ],
    // Stroke 2: top curve (ends at vertical bar)
    [
      { x: 25, y: 25 },
      { x: 89.4, y: 25 },
      { x: 110.6, y: 32.3 },
      { x: 117.9, y: 39.5 },
      { x: 125.2, y: 53.5 },
      { x: 125.2, y: 68.1 },
      { x: 117.9, y: 82.1 },
      { x: 110.6, y: 89.4 },
      { x: 89.4, y: 96.6 },
      { x: 25, y: 96.6 },
    ],
    // Stroke 3: bottom curve (starts at junction where curves meet)
    [
      { x: 89.4, y: 96.6 },
      { x: 110.6, y: 103.6 },
      { x: 117.9, y: 110.6 },
      { x: 125.2, y: 125.2 },
      { x: 125.2, y: 146.5 },
      { x: 117.9, y: 160.7 },
      { x: 110.6, y: 167.9 },
      { x: 89.4, y: 175 },
      { x: 25, y: 175 },
    ]
  ],
  'C': [
    [
      { x: 132.2, y: 60.8 },
      { x: 124.9, y: 46.5 },
      { x: 110.6, y: 32.3 },
      { x: 96.4, y: 25 },
      { x: 67.8, y: 25 },
      { x: 53.5, y: 32.3 },
      { x: 39.3, y: 46.5 },
      { x: 32, y: 60.8 },
      { x: 25, y: 82.1 },
      { x: 25, y: 117.9 },
      { x: 32, y: 139.2 },
      { x: 39.3, y: 153.6 },
      { x: 53.5, y: 167.9 },
      { x: 67.8, y: 175 },
      { x: 96.4, y: 175 },
      { x: 110.6, y: 167.9 },
      { x: 124.9, y: 153.6 },
      { x: 132.2, y: 139.2 },
    ]
  ],
  'D': [
    [
      { x: 25, y: 25 },
      { x: 25, y: 175 },
    ],
    [
      { x: 25, y: 25 },
      { x: 75.1, y: 25 },
      { x: 96.6, y: 32.3 },
      { x: 110.6, y: 46.5 },
      { x: 117.9, y: 60.8 },
      { x: 125.2, y: 82.1 },
      { x: 125.2, y: 117.9 },
      { x: 117.9, y: 139.2 },
      { x: 110.6, y: 153.6 },
      { x: 96.6, y: 167.9 },
      { x: 75.1, y: 175 },
      { x: 25, y: 175 },
    ]
  ],
  'E': [
    [
      { x: 25, y: 25 },
      { x: 25, y: 175 },
    ],
    [
      { x: 25, y: 25 },
      { x: 117.9, y: 25 },
    ],
    [
      { x: 25, y: 96.6 },
      { x: 82.1, y: 96.6 },
    ],
    [
      { x: 25, y: 175 },
      { x: 117.9, y: 175 },
    ]
  ],
  'F': [
    [
      { x: 25, y: 25 },
      { x: 25, y: 175 },
    ],
    [
      { x: 25, y: 25 },
      { x: 117.9, y: 25 },
    ],
    [
      { x: 25, y: 96.6 },
      { x: 82.1, y: 96.6 },
    ]
  ],
  'G': [
    [
      { x: 132.2, y: 60.8 },
      { x: 124.9, y: 46.5 },
      { x: 110.6, y: 32.3 },
      { x: 96.4, y: 25 },
      { x: 67.8, y: 25 },
      { x: 53.5, y: 32.3 },
      { x: 39.3, y: 46.5 },
      { x: 32, y: 60.8 },
      { x: 25, y: 82.1 },
      { x: 25, y: 117.9 },
      { x: 32, y: 139.2 },
      { x: 39.3, y: 153.6 },
      { x: 53.5, y: 167.9 },
      { x: 67.8, y: 175 },
      { x: 96.4, y: 175 },
      { x: 110.6, y: 167.9 },
      { x: 124.9, y: 153.6 },
      { x: 132.2, y: 139.2 },
      { x: 132.2, y: 117.9 },
    ],
    [
      { x: 96.4, y: 117.9 },
      { x: 132.2, y: 117.9 },
    ]
  ],
  'H': [
    // Stroke 1: left vertical bar
    [
      { x: 25, y: 25 },
      { x: 25, y: 175 },
    ],
    // Stroke 2: horizontal bar
    [
      { x: 25, y: 96.6 },
      { x: 125.2, y: 96.6 },
    ],
    // Stroke 3: right vertical bar
    [
      { x: 125.2, y: 25 },
      { x: 125.2, y: 175 },
    ]
  ],
  'I': [
    [
      { x: 25, y: 25 },
      { x: 25, y: 175 },
    ]
  ],
  'J': [
    [
      { x: 96.1, y: 25 },
      { x: 96.1, y: 139.2 },
      { x: 89.1, y: 160.7 },
      { x: 82.1, y: 167.9 },
      { x: 67.6, y: 175 },
      { x: 53.5, y: 175 },
      { x: 39, y: 167.9 },
      { x: 32, y: 160.7 },
      { x: 25, y: 139.2 },
      { x: 25, y: 125.2 },
    ]
  ],
  'K': [
    [
      { x: 25, y: 25 },
      { x: 25, y: 175 },
    ],
    [
      { x: 125.2, y: 25 },
      { x: 25, y: 125.2 },
    ],
    [
      { x: 60.8, y: 89.4 },
      { x: 125.2, y: 175 },
    ]
  ],
  'L': [
    [
      { x: 25, y: 25 },
      { x: 25, y: 175 },
      { x: 110.6, y: 175 },
    ]
  ],
  'M': [
    [
      { x: 25, y: 25 },
      { x: 25, y: 175 },
    ],
    [
      { x: 25, y: 25 },
      { x: 82.1, y: 175 },
      { x: 139.2, y: 25 },
      { x: 139.2, y: 175 },
    ]
  ],
  'N': [
    [
      { x: 25, y: 25 },
      { x: 25, y: 175 },
    ],
    [
      { x: 25, y: 25 },
      { x: 125.2, y: 175 },
      { x: 125.2, y: 25 },
    ]
  ],
  'O': [
    [
      { x: 67.8, y: 25 },
      { x: 53.5, y: 32.3 },
      { x: 39.3, y: 46.5 },
      { x: 32, y: 60.8 },
      { x: 25, y: 82.1 },
      { x: 25, y: 117.9 },
      { x: 32, y: 139.2 },
      { x: 39.3, y: 153.6 },
      { x: 53.5, y: 167.9 },
      { x: 67.8, y: 175 },
      { x: 96.4, y: 175 },
      { x: 110.6, y: 167.9 },
      { x: 124.9, y: 153.6 },
      { x: 132.2, y: 139.2 },
      { x: 139.2, y: 117.9 },
      { x: 139.2, y: 82.1 },
      { x: 132.2, y: 60.8 },
      { x: 124.9, y: 46.5 },
      { x: 110.6, y: 32.3 },
      { x: 96.4, y: 25 },
      { x: 67.8, y: 25 },
    ]
  ],
  'P': [
    [
      { x: 25, y: 25 },
      { x: 25, y: 175 },
    ],
    [
      { x: 25, y: 25 },
      { x: 89.4, y: 25 },
      { x: 110.6, y: 32.3 },
      { x: 117.9, y: 39.5 },
      { x: 125.2, y: 53.5 },
      { x: 125.2, y: 75.1 },
      { x: 117.9, y: 89.4 },
      { x: 110.6, y: 96.6 },
      { x: 89.4, y: 103.6 },
      { x: 25, y: 103.6 },
    ]
  ],
  'Q': [
    [
      { x: 64.1, y: 25 },
      { x: 51.1, y: 31.6 },
      { x: 38, y: 44.7 },
      { x: 31.4, y: 57.7 },
      { x: 25, y: 77.1 },
      { x: 25, y: 109.8 },
      { x: 31.4, y: 129.3 },
      { x: 38, y: 142.4 },
      { x: 51.1, y: 155.4 },
      { x: 64.1, y: 162 },
      { x: 90.2, y: 162 },
      { x: 103.2, y: 155.4 },
      { x: 116.2, y: 142.4 },
      { x: 122.9, y: 129.3 },
      { x: 129.3, y: 109.8 },
      { x: 129.3, y: 77.1 },
      { x: 122.9, y: 57.7 },
      { x: 116.2, y: 44.7 },
      { x: 103.2, y: 31.6 },
      { x: 90.2, y: 25 },
      { x: 64.1, y: 25 },
    ],
    [
      { x: 83.6, y: 135.9 },
      { x: 122.9, y: 175 },
    ]
  ],
  'R': [
    [
      { x: 25, y: 25 },
      { x: 25, y: 175 },
    ],
    [
      { x: 25, y: 25 },
      { x: 89.4, y: 25 },
      { x: 110.6, y: 32.3 },
      { x: 117.9, y: 39.5 },
      { x: 125.2, y: 53.5 },
      { x: 125.2, y: 68.1 },
      { x: 117.9, y: 82.1 },
      { x: 110.6, y: 89.4 },
      { x: 89.4, y: 96.6 },
      { x: 25, y: 96.6 },
    ],
    [
      { x: 75.1, y: 96.6 },
      { x: 125.2, y: 175 },
    ]
  ],
  'S': [
    [
      { x: 124.9, y: 46.5 },
      { x: 110.6, y: 32.3 },
      { x: 89.1, y: 25 },
      { x: 60.6, y: 25 },
      { x: 39.3, y: 32.3 },
      { x: 25, y: 46.5 },
      { x: 25, y: 60.8 },
      { x: 32, y: 75.1 },
      { x: 39.3, y: 82.1 },
      { x: 53.5, y: 89.4 },
      { x: 96.4, y: 103.6 },
      { x: 110.6, y: 110.6 },
      { x: 117.7, y: 117.9 },
      { x: 124.9, y: 132.2 },
      { x: 124.9, y: 153.6 },
      { x: 110.6, y: 167.9 },
      { x: 89.1, y: 175 },
      { x: 60.6, y: 175 },
      { x: 39.3, y: 167.9 },
      { x: 25, y: 153.6 },
    ]
  ],
  'T': [
    [
      { x: 74.8, y: 25 },
      { x: 74.8, y: 175 },
    ],
    [
      { x: 25, y: 25 },
      { x: 124.9, y: 25 },
    ]
  ],
  'U': [
    [
      { x: 25, y: 25 },
      { x: 25, y: 132.2 },
      { x: 32.3, y: 153.6 },
      { x: 46.5, y: 167.9 },
      { x: 68.1, y: 175 },
      { x: 82.1, y: 175 },
      { x: 103.6, y: 167.9 },
      { x: 117.9, y: 153.6 },
      { x: 125.2, y: 132.2 },
      { x: 125.2, y: 25 },
    ]
  ],
  'V': [
    [
      { x: 25, y: 25 },
      { x: 82.1, y: 175 },
      { x: 139.2, y: 25 },
    ]
  ],
  'W': [
    [
      { x: 25, y: 25 },
      { x: 60.6, y: 175 },
      { x: 96.1, y: 25 },
      { x: 131.9, y: 175 },
      { x: 167.7, y: 25 },
    ]
  ],
  'X': [
    [
      { x: 25, y: 25 },
      { x: 124.9, y: 175 },
    ],
    [
      { x: 124.9, y: 25 },
      { x: 25, y: 175 },
    ]
  ],
  'Y': [
    [
      { x: 25, y: 25 },
      { x: 82.1, y: 96.6 },
    ],
    [
      { x: 139.2, y: 25 },
      { x: 82.1, y: 96.6 },
      { x: 82.1, y: 175 },
    ]
  ],
  'Z': [
    [
      { x: 25, y: 25 },
      { x: 124.9, y: 25 },
      { x: 25, y: 175 },
      { x: 124.9, y: 175 },
    ]
  ],
  'a': [
    [
      { x: 153.6, y: 57.3 },
      { x: 132.1, y: 35.5 },
      { x: 110.7, y: 25 },
      { x: 78.4, y: 25 },
      { x: 57.3, y: 35.5 },
      { x: 35.5, y: 57.3 },
      { x: 25, y: 89.3 },
      { x: 25, y: 110.7 },
      { x: 35.5, y: 142.9 },
      { x: 57.3, y: 164.3 },
      { x: 78.4, y: 175 },
      { x: 110.7, y: 175 },
      { x: 132.1, y: 164.3 },
      { x: 153.6, y: 142.9 },
    ],
    [
      { x: 153.6, y: 25 },
      { x: 153.6, y: 175 },
    ]
  ],
  'b': [
    [
      { x: 25, y: 25 },
      { x: 25, y: 175 },
    ],
    [
      { x: 25, y: 96.6 },
      { x: 39.5, y: 82.1 },
      { x: 53.5, y: 75.1 },
      { x: 75.1, y: 75.1 },
      { x: 89.4, y: 82.1 },
      { x: 103.6, y: 96.6 },
      { x: 110.6, y: 117.9 },
      { x: 110.6, y: 132.2 },
      { x: 103.6, y: 153.6 },
      { x: 89.4, y: 167.9 },
      { x: 75.1, y: 175 },
      { x: 53.5, y: 175 },
      { x: 39.5, y: 167.9 },
      { x: 25, y: 153.6 },
    ]
  ],
  'c': [
    [
      { x: 153.6, y: 57.3 },
      { x: 132.1, y: 35.5 },
      { x: 110.7, y: 25 },
      { x: 78.4, y: 25 },
      { x: 57.3, y: 35.5 },
      { x: 35.5, y: 57.3 },
      { x: 25, y: 89.3 },
      { x: 25, y: 110.7 },
      { x: 35.5, y: 142.9 },
      { x: 57.3, y: 164.3 },
      { x: 78.4, y: 175 },
      { x: 110.7, y: 175 },
      { x: 132.1, y: 164.3 },
      { x: 153.6, y: 142.9 },
    ]
  ],
  'd': [
    [
      { x: 110.6, y: 96.6 },
      { x: 96.4, y: 82.1 },
      { x: 82.1, y: 75.1 },
      { x: 60.6, y: 75.1 },
      { x: 46.5, y: 82.1 },
      { x: 32, y: 96.6 },
      { x: 25, y: 117.9 },
      { x: 25, y: 132.2 },
      { x: 32, y: 153.6 },
      { x: 46.5, y: 167.9 },
      { x: 60.6, y: 175 },
      { x: 82.1, y: 175 },
      { x: 96.4, y: 167.9 },
      { x: 110.6, y: 153.6 },
    ],
    [
      { x: 110.6, y: 25 },
      { x: 110.6, y: 175 },
    ]
  ],
  'e': [
    [
      { x: 25, y: 89.3 },
      { x: 153.6, y: 89.3 },
      { x: 153.6, y: 67.9 },
      { x: 143, y: 46.4 },
      { x: 132.1, y: 35.5 },
      { x: 110.7, y: 25 },
      { x: 78.4, y: 25 },
      { x: 57.3, y: 35.5 },
      { x: 35.5, y: 57.3 },
      { x: 25, y: 89.3 },
      { x: 25, y: 110.7 },
      { x: 35.5, y: 142.9 },
      { x: 57.3, y: 164.3 },
      { x: 78.4, y: 175 },
      { x: 110.7, y: 175 },
      { x: 132.1, y: 164.3 },
      { x: 153.6, y: 142.9 },
    ]
  ],
  'f': [
    [
      { x: 82.1, y: 25 },
      { x: 67.6, y: 25 },
      { x: 53.5, y: 32.3 },
      { x: 46.3, y: 53.5 },
      { x: 46.3, y: 175 },
    ],
    [
      { x: 25, y: 75.1 },
      { x: 74.8, y: 75.1 },
    ]
  ],
  'g': [
    [
      { x: 110.8, y: 46.6 },
      { x: 96.5, y: 32 },
      { x: 82.2, y: 25 },
      { x: 60.6, y: 25 },
      { x: 46.6, y: 32 },
      { x: 32, y: 46.6 },
      { x: 25, y: 67.9 },
      { x: 25, y: 82.2 },
      { x: 32, y: 103.6 },
      { x: 46.6, y: 117.9 },
      { x: 60.6, y: 125.1 },
      { x: 82.2, y: 125.1 },
      { x: 96.5, y: 117.9 },
      { x: 110.8, y: 103.6 },
    ],
    [
      { x: 110.8, y: 25 },
      { x: 110.8, y: 139.4 },
      { x: 103.7, y: 160.9 },
      { x: 96.5, y: 168 },
      { x: 82.2, y: 175 },
      { x: 60.6, y: 175 },
      { x: 46.6, y: 168 },
    ]
  ],
  'h': [
    [
      { x: 25, y: 25 },
      { x: 25, y: 175 },
    ],
    [
      { x: 25, y: 103.6 },
      { x: 46.5, y: 82.1 },
      { x: 60.8, y: 75.1 },
      { x: 82.1, y: 75.1 },
      { x: 96.6, y: 82.1 },
      { x: 103.6, y: 103.6 },
      { x: 103.6, y: 175 },
    ]
  ],
  'i': [
    // Stroke 1: main vertical line
    [
      { x: 31.7, y: 79.5 },
      { x: 31.7, y: 175 },
    ],
    // Stroke 2: dot on top
    [
      { x: 31.7, y: 31.7 },
    ]
  ],
  'j': [
    // Stroke 1: main vertical line with curve
    [
      { x: 51, y: 66.4 },
      { x: 51, y: 154.4 },
      { x: 45.7, y: 169.9 },
      { x: 35.4, y: 175 },
      { x: 25, y: 175 },
    ],
    // Stroke 2: dot on top
    [
      { x: 51, y: 30.1 },
    ]
  ],
  'k': [
    [
      { x: 25, y: 25 },
      { x: 25, y: 175 },
    ],
    [
      { x: 96.6, y: 75.1 },
      { x: 25, y: 146.5 },
    ],
    [
      { x: 53.5, y: 117.9 },
      { x: 103.6, y: 175 },
    ]
  ],
  'l': [
    [
      { x: 25, y: 25 },
      { x: 25, y: 175 },
    ]
  ],
  'm': [
    [
      { x: 25, y: 79.7 },
      { x: 25, y: 175 },
    ],
    [
      { x: 25, y: 106.9 },
      { x: 45.5, y: 86.4 },
      { x: 59.1, y: 79.7 },
      { x: 79.5, y: 79.7 },
      { x: 93.3, y: 86.4 },
      { x: 100, y: 106.9 },
      { x: 100, y: 175 },
    ],
    [
      { x: 100, y: 106.9 },
      { x: 120.5, y: 86.4 },
      { x: 133.9, y: 79.7 },
      { x: 154.5, y: 79.7 },
      { x: 168.1, y: 86.4 },
      { x: 175, y: 106.9 },
      { x: 175, y: 175 },
    ]
  ],
  'n': [
    [
      { x: 25, y: 25 },
      { x: 25, y: 175 },
    ],
    [
      { x: 25, y: 67.9 },
      { x: 57.3, y: 35.5 },
      { x: 78.7, y: 25 },
      { x: 110.7, y: 25 },
      { x: 132.5, y: 35.5 },
      { x: 143, y: 67.9 },
      { x: 143, y: 175 },
    ]
  ],
  'o': [
    [
      { x: 78.4, y: 25 },
      { x: 57.3, y: 35.5 },
      { x: 35.5, y: 57.3 },
      { x: 25, y: 89.3 },
      { x: 25, y: 110.7 },
      { x: 35.5, y: 142.9 },
      { x: 57.3, y: 164.3 },
      { x: 78.4, y: 175 },
      { x: 110.7, y: 175 },
      { x: 132.1, y: 164.3 },
      { x: 153.6, y: 142.9 },
      { x: 164.1, y: 110.7 },
      { x: 164.1, y: 89.3 },
      { x: 153.6, y: 57.3 },
      { x: 132.1, y: 35.5 },
      { x: 110.7, y: 25 },
      { x: 78.4, y: 25 },
    ]
  ],
  'p': [
    [
      { x: 25, y: 25 },
      { x: 25, y: 175 },
    ],
    [
      { x: 25, y: 46.6 },
      { x: 39.5, y: 32 },
      { x: 53.6, y: 25 },
      { x: 75.2, y: 25 },
      { x: 89.4, y: 32 },
      { x: 103.7, y: 46.6 },
      { x: 110.8, y: 67.9 },
      { x: 110.8, y: 82.2 },
      { x: 103.7, y: 103.6 },
      { x: 89.4, y: 117.9 },
      { x: 75.2, y: 125.1 },
      { x: 53.6, y: 125.1 },
      { x: 39.5, y: 117.9 },
      { x: 25, y: 103.6 },
    ]
  ],
  'q': [
    [
      { x: 110.8, y: 46.6 },
      { x: 96.5, y: 32 },
      { x: 82.2, y: 25 },
      { x: 60.6, y: 25 },
      { x: 46.6, y: 32 },
      { x: 32, y: 46.6 },
      { x: 25, y: 67.9 },
      { x: 25, y: 82.2 },
      { x: 32, y: 103.6 },
      { x: 46.6, y: 117.9 },
      { x: 60.6, y: 125.1 },
      { x: 82.2, y: 125.1 },
      { x: 96.5, y: 117.9 },
      { x: 110.8, y: 103.6 },
    ],
    [
      { x: 110.8, y: 25 },
      { x: 110.8, y: 175 },
    ]
  ],
  'r': [
    [
      { x: 25, y: 25 },
      { x: 25, y: 175 },
    ],
    [
      { x: 25, y: 89.3 },
      { x: 35.9, y: 57.3 },
      { x: 57.3, y: 35.5 },
      { x: 78.7, y: 25 },
      { x: 110.7, y: 25 },
    ]
  ],
  's': [
    [
      { x: 143, y: 57.3 },
      { x: 132.1, y: 35.5 },
      { x: 100.2, y: 25 },
      { x: 67.9, y: 25 },
      { x: 35.5, y: 35.5 },
      { x: 25, y: 57.3 },
      { x: 35.5, y: 78.4 },
      { x: 57.3, y: 89.3 },
      { x: 110.7, y: 100.2 },
      { x: 132.1, y: 110.7 },
      { x: 143, y: 132.1 },
      { x: 143, y: 142.9 },
      { x: 132.1, y: 164.3 },
      { x: 100.2, y: 175 },
      { x: 67.9, y: 175 },
      { x: 35.5, y: 164.3 },
      { x: 25, y: 142.9 },
    ]
  ],
  't': [
    [
      { x: 46.3, y: 25 },
      { x: 46.3, y: 146.5 },
      { x: 53.5, y: 167.9 },
      { x: 67.6, y: 175 },
      { x: 82.1, y: 175 },
    ],
    [
      { x: 25, y: 75.1 },
      { x: 74.8, y: 75.1 },
    ]
  ],
  'u': [
    [
      { x: 25, y: 25 },
      { x: 25, y: 132.1 },
      { x: 35.9, y: 164.3 },
      { x: 57.3, y: 175 },
      { x: 89.6, y: 175 },
      { x: 110.7, y: 164.3 },
      { x: 143, y: 132.1 },
    ],
    [
      { x: 143, y: 25 },
      { x: 143, y: 175 },
    ]
  ],
  'v': [
    [
      { x: 25, y: 25 },
      { x: 88.9, y: 175 },
      { x: 153.6, y: 25 },
    ]
  ],
  'w': [
    [
      { x: 25, y: 43.8 },
      { x: 62.5, y: 175 },
      { x: 100, y: 43.8 },
      { x: 137.5, y: 175 },
      { x: 175, y: 43.8 },
    ]
  ],
  'x': [
    [
      { x: 25, y: 25 },
      { x: 143, y: 175 },
    ],
    [
      { x: 143, y: 25 },
      { x: 25, y: 175 },
    ]
  ],
  'y': [
    [
      { x: 32.3, y: 25 },
      { x: 74.9, y: 125.1 },
    ],
    [
      { x: 118, y: 25 },
      { x: 74.9, y: 125.1 },
      { x: 60.9, y: 153.7 },
      { x: 46.3, y: 168 },
      { x: 32.3, y: 175 },
      { x: 25, y: 175 },
    ]
  ],
  'z': [
    [
      { x: 25, y: 25 },
      { x: 143, y: 25 },
      { x: 25, y: 175 },
      { x: 143, y: 175 },
    ]
  ],
};

// Default export
export default strokePaths;
